export default "__VITE_ASSET__CCy23NLM__"